/**
 * Gemini API設定
 *
 * APIキーはクライアントに保持しない。Gemini の呼び出しは Firebase AI Logic
 * （geminiClient.ts）経由で行うため、ここにはモデルと生成パラメータのみを定義する。
 */
export const GEMINI_CONFIG = {
  /** 使用するモデル */
  model: 'gemini-2.5-flash',
  /** 最大出力トークン数 */
  maxOutputTokens: 8192,
  /** 温度パラメータ（0-1、高いほど創造的） */
  temperature: 0.7,
} as const;

/**
 * AI分析の日次上限
 * Gemini 2.5 Pro無料枠は50 RPD、安全マージンとして30回/日に設定
 */
export const AI_ANALYSIS_DAILY_LIMIT = 30;

/**
 * AI交配提案のデフォルト設定
 */
export const AI_MATING_CONFIG = {
  /** 候補オス犬の最大数 */
  maxCandidates: 10,
  /** 近親交配を回避するか */
  avoidInbreeding: true,
  /** 最小世代差（近親回避時） */
  minimumGenerations: 3,
  /** 祖先取得の世代数 */
  ancestorGenerations: 6,
} as const;

/**
 * 免責事項テキスト
 */
export const DISCLAIMER =
  'この提案はAIによる参考情報です。交配の最終判断は、獣医師との相談やブリーダーの経験に基づいて行ってください。';

/**
 * PDF解析の設定
 */
export const PDF_ANALYSIS_CONFIG = {
  /** Vision対応モデル（Gemini 2.0以降） */
  model: 'gemini-2.5-flash',
  /** 最大ファイルサイズ（MB） */
  maxFileSizeMB: 10,
  /** サポートするファイルタイプ */
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/png'] as const,
  /** 最大出力トークン数 */
  maxOutputTokens: 4096,
  /** 温度パラメータ（低めで精度重視） */
  temperature: 0.2,
} as const;

/**
 * PDF解析の免責事項
 */
export const PDF_ANALYSIS_DISCLAIMER =
  'この解析結果はAIによる自動認識です。抽出された情報は必ず原本と照合し、正確性を確認してください。';
